module.exports = __webpack_public_path__ + "assets/pagoTarjetaOnlinea4703d9e.png";